module.exports = __webpack_public_path__ + "static/media/history_13.245073ee.jpg";